import { load } from 'cheerio';
import { useSettingsStore } from '@/store/settings/settingsStore';

export function extractERSProductDescription(htmlSource: string): string {
    const $ = load(htmlSource);
    const { settings } = useSettingsStore();
    const isDebug = settings.useDebug;
    let descriptionHtml = '';

    const appendContent = (content: string, source: string) => {
        if (!content) {
            if (isDebug) console.log(`Content from ${source} is empty.`);
            return;
        }
        if (descriptionHtml.includes(content)) {
            if (isDebug) console.log(`Content from ${source} already included.`);
            return;
        }
        if (isDebug) console.log(`Appending content from: ${source}`);
        descriptionHtml += content;
    };

    // 1. .panel-body > div[style*="text-align:left"]
    const leftAligned = $('.panel-body > div[style*="text-align:left"]')
        .map((_, el) => $(el).html()?.trim() || '')
        .get()
        .join('');
    appendContent(leftAligned, 'leftAlignedPanelDescription');

    // 2. .description-container
    const descriptionContainer = $('.description-container')
        .map((_, el) => $(el).html()?.trim() || '')
        .get()
        .join('');
    appendContent(descriptionContainer, 'descriptionContainer');

    // 3. any left-aligned div inside .panel-body
    const fallback = $('.panel-body')
        .find('div')
        .filter((_, el) => $(el).css('text-align') === 'left')
        .map((_, el) => $(el).html()?.trim() || '')
        .get()
        .join('');
    appendContent(fallback, 'additionalFallbackDescription');

    // 4. .premium-video
    const videoSection = $('.premium-video')
        .map((_, el) => $(el).html()?.trim() || '')
        .get()
        .join('');
    appendContent(videoSection, 'videoSection');

    // 5. .feature-section
    const featureSection = $('.feature-section')
        .map((_, el) => $(el).html()?.trim() || '')
        .get()
        .join('');
    appendContent(featureSection, 'featureSection');

    // 6. .text-area
    const textArea = $('.text-area')
        .map((_, el) => $(el).html()?.trim() || '')
        .get()
        .join('');
    appendContent(textArea, 'textArea');

    // 7. .panel-default outside .item-page
    const panelDefault = $('.panel-default')
        .filter((_, el) => $(el).closest('.item-page').length === 0)
        .map((_, el) => $(el).html()?.trim() || '')
        .get()
        .join('');
    appendContent(panelDefault, 'panelDefault');

    // Remove stray <span>Description</span>
    return descriptionHtml.replace(/<span[^>]*>\s*Description\s*<\/span>/gi, '');
}
